import React from "react";
import { motion } from "framer-motion";

const Contact = () => {
  return (
    <section className="h-screen flex flex-col justify-center items-center text-center snap-start">
      <h2 className="text-3xl font-semibold text-secondary-500">Get in Touch</h2>
      <p className="mt-4">Let's build something amazing together.</p>
      <motion.a
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        href="mailto:contact@elseware.tech"
        className="mt-6 inline-block bg-secondary-500 text-dark-900 px-6 py-3 rounded-lg font-bold hover:bg-secondary-600"
      >
        Contact Us
      </motion.a>
    </section>
  );
};

export default Contact;